var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 565.5 127.92",
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{font-size:108.59px;font-family:Mont-Heavy,\n            Mont;font-weight:800;}.cls-1,.cls-2{fill:#0052bc;}.cls-1{letter-spacing:0.12em;}.cls-3{fill:#fff;}.cls-4{fill:#333;letter-spacing:0.05em;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 92.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, "M  N")), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.45,87.71V79.65c-10.19-.66-18.59-4.82-25-12.78a32.42,32.42,0,0,1-7.23-22.68,33.62,33.62,0,0,1,66.82-3.14c2.92,19.88-11.69,36.59-29.15,38.39v8.27h21.24a2.69,2.69,0,0,1,2.73,3.61,2.6,2.6,0,0,1-2.34,1.76,6.43,6.43,0,0,1-.76,0H126.56a5.71,5.71,0,0,1-1.17-.07,2.68,2.68,0,0,1,.61-5.3c3.84,0,7.68,0,11.52,0Zm1.37-24.21A17.49,17.49,0,1,0,131.35,46,17.51,17.51,0,0,0,148.82,63.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 148.83,
    cy: 45.86,
    r: 17.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 148.83,
    cy: 45.88,
    r: 9.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 154.59,
    cy: 38.64,
    r: 3.15
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(287.94 92.3)"
  }, "Cam")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.61f16ddf89a26fcbdf3e983d2fced94d.svg";
export { ForwardRef as ReactComponent };